import { render, staticRenderFns } from "./EmailRecipientsDialog.vue?vue&type=template&id=160c5027&scoped=true"
import script from "./EmailRecipientsDialog.vue?vue&type=script&lang=js"
export * from "./EmailRecipientsDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailRecipientsDialog.vue?vue&type=style&index=0&id=160c5027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c5027",
  null
  
)

export default component.exports